document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-ir-ba]')
  if (!section) return

  const beforeImg = section.querySelector('[data-ir-ba-before]')
  const afterImg = section.querySelector('[data-ir-ba-after]')
  const quoteBox = section.querySelector('[data-ir-ba-quote]')
  const users = section.querySelectorAll('[data-ir-ba-user]')

  const modal = section.querySelector('[data-ir-ba-modal]')
  const modalImg = section.querySelector('[data-ir-ba-modal-img]')

  const storyPanel = section.querySelector('[data-ir-ba-story]')
  const storyText = section.querySelector('[data-ir-ba-story-text]')
  const storyBtn = section.querySelector('[data-ir-ba-story-btn]')
  const imagesWrap = section.querySelector('.ir-ba__images')

  const isMobile = () => window.innerWidth <= 768

  if (users.length) {
    storyText.innerText = users[0].dataset.quote
  }

  users.forEach(user => {
    user.addEventListener('click', () => {
      beforeImg.src = user.dataset.before
      afterImg.src = user.dataset.after
      quoteBox.innerText = user.dataset.quote
      storyText.innerText = user.dataset.quote

      users.forEach(u => u.classList.remove('is-active'))
      user.classList.add('is-active')

      if (isMobile()) {
        storyPanel.classList.remove('is-active')
        storyBtn.classList.remove('is-open')
        imagesWrap.classList.remove('is-masked')
      }
    })
  })

  const openModal = src => {
    modalImg.src = src
    modal.classList.add('is-active')
  }

  beforeImg.addEventListener('click', () => openModal(beforeImg.src))
  afterImg.addEventListener('click', () => openModal(afterImg.src))

  modal.addEventListener('click', e => {
    if (e.target === modal) {
      modal.classList.remove('is-active')
      modalImg.src = ''
    }
  })

storyBtn.addEventListener('click', () => {
  if (!isMobile()) return

  const isOpen = storyPanel.classList.toggle('is-active')

  storyBtn.classList.toggle('is-open')
  imagesWrap.classList.toggle('is-masked')

  storyBtn.firstChild.textContent = isOpen ? 'Close Story ' : 'Read Story '
})

// IR Before After Reviews Animation System
class IRBeforeAfterAnimations {
  constructor() {
    this.animatedElements = [];
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupAnimations());
    } else {
      this.setupAnimations();
    }
  }

  setupAnimations() {
    // Find all elements with animation classes
    const animateElements = document.querySelectorAll('.ir-animate-fade-up, .ir-animate-slide-left, .ir-animate-slide-right, .ir-animate-scale');
    
    if (animateElements.length === 0) return;

    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateElement(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all animation elements
    animateElements.forEach(element => {
      observer.observe(element);
    });
  }

  animateElement(element) {
    const delay = parseInt(element.getAttribute('data-delay')) || 0;
    setTimeout(() => {
      element.classList.add('ir-animated');
    }, delay);
  }
}

// Initialize animations
const irBeforeAfterAnimations = new IRBeforeAfterAnimations();

// Autoplay user buttons every 5 seconds, pause on hover
if (users.length > 1) {
  let currentIndex = 0;
  let autoplayTimer = null;
  let isPaused = false;

  const triggerUser = (index) => {
    users[index].click();
    currentIndex = index;
  };

  const startAutoplay = () => {
    autoplayTimer = setInterval(() => {
      if (!isPaused) {
        const nextIndex = (currentIndex + 1) % users.length;
        triggerUser(nextIndex);
      }
    }, 5000);
  };

  // Pause on hover anywhere in the section
  section.addEventListener('mouseenter', () => { isPaused = true; });
  section.addEventListener('mouseleave', () => { isPaused = false; });

  startAutoplay();
}
})
